import MapView from "@teovilla/react-native-web-maps";


export default MapView;